const routesPath = {
  ALL: '*',
  DEFAULT: '/',
  HOME: '/home',

  JOBS: '/jobs',
  JOB_BY_ID: '/jobs/:teamId/:rootJobId',
  JOB_CUSTOMER_BY_ID: '/jobs/:teamId/:rootJobId/customer/:customerId',
  CREATE_JOB: '/jobs/create',
  EDIT_JOB: '/jobs/edit/:jobId',
  DUPLICATE_JOB: '/jobs/duplicate/:jobId',
  JOB_BY_ID_EDIT_STATUS: '/jobs/:teamId/:rootJobId/job/editStatus',
  JOB_JOB_DETAILS: '/jobs/:teamId/:rootJobId/jobs/:jobId',
  JOB_INVOICE_BY_ID: '/jobs/:teamId/:rootJobId/invoice/:invoiceId',
  JOB_INVOICE_SHARE: '/jobs/:teamId/:rootJobId/share-invoice/:invoiceId',
  JOB_INVOICE_PENDING_SHARE: '/jobs/:teamId/:rootJobId/share-pending-invoice/:invoiceId',
  JOB_INVOICE_PENDING_SHARE_QR: '/jobs/:teamId/:rootJobId/share-pending-invoice/:invoiceId/share-qr',
  JOB_INVOICE_PENDING_SHARE_URL: '/jobs/:teamId/:rootJobId/share-pending-invoice/:invoiceId/share-url',
  JOB_INVOICE_RECORD_PAYMENT: '/jobs/:teamId/:rootJobId/record-payment/:invoiceId',
  JOB_RECEIPT_BY_ID: '/jobs/:teamId/:rootJobId/receipt/:receiptId',
  JOB_INVOICE_DETAILS: '/jobs/:teamId/:rootJobId/invoice-details/:invoiceId',
  JOB_INVOICE_DELETE: '/jobs/:teamId/:rootJobId/delete-invoice/:invoiceId',
  JOB_PAYOUT: '/jobs/:teamId/:rootJobId/payout/:payoutId',
  JOB_DISPUTE_BY_ID: '/jobs/:teamId/:rootJobId/dispute/:disputeId',
  JOB_RECEIPT_SHARE: '/jobs/:teamId/:rootJobId/share-receipt/:receiptId',
  JOB_RECEIPT_CREATE_REFUND: '/jobs/:teamId/:rootJobId/create-refund/:receiptId',
  JOB_RECEIPT_INITIATE_REFUND: '/jobs/:teamId/:rootJobId/initiate-refund/:receiptId',
  JOB_RECEIPT_REFUND_SUCCESS: '/jobs/:teamId/:rootJobId/refund-success/:receiptId',
  JOB_RECEIPT_REFUND_FAILED: '/jobs/:teamId/:rootJobId/refund-failed/:receiptId',
  JOB_RECEIPT_REFUND: '/jobs/:teamId/:rootJobId/refund-receipt/:receiptId',
  JOB_REFUND_RECEIPT_SHARE: '/jobs/:teamId/:rootJobId/share-refund-receipt/:receiptId',
  JOB_ESTIMATE: '/jobs/:teamId/:rootJobId/estimate/:estimateId',
  JOB_ESTIMATE_SHARE: '/jobs/:teamId/:rootJobId/share-estimate/:estimateId',
  JOB_INVOICE_EDIT_AMOUNT: '/jobs/:teamId/:rootJobId/invoice/:invoiceId/edit-amount',
  JOB_INVOICE_COLLECT_PAYMENT: '/jobs/:teamId/:rootJobId/invoice/:invoiceId/collect-payment',
  JOB_INVOICE_HISTORY: '/jobs/:teamId/:rootJobId/history/:invoiceId',
  JOB_INVOICE_ISSUE_REFUND: '/jobs/:teamId/:rootJobId/issue-refund/:invoiceId',

  INVOICE: '/invoice',
  INVOICES: '/invoices',
  INVOICE_BY_ID: '/invoices/:teamId/:rootInvoiceId/invoice',
  INVOICE_BY_ID_DETAILS: '/invoices/:teamId/:rootInvoiceId/invoice-details',
  INVOICE_CUSTOMER_BY_ID: '/invoices/:teamId/:rootInvoiceId/customer/:customerId',
  INVOICE_INVOICE_BY_ID: '/invoices/:teamId/:rootInvoiceId/invoice/:invoiceId',
  INVOICE_INVOICE_DETAILS: '/invoices/:teamId/:rootInvoiceId/invoice-details/:invoiceId',

  INVOICE_SHARE: '/invoices/:teamId/:rootInvoiceId/share-invoice',
  INVOICE_PENDING_SHARE: '/invoices/:teamId/:rootInvoiceId/share-pending-invoice',
  INVOICE_PENDING_SHARE_QR: '/invoices/:teamId/:rootInvoiceId/share-pending-invoice/share-qr',
  INVOICE_PENDING_SHARE_URL: '/invoices/:teamId/:rootInvoiceId/share-pending-invoice/share-url',
  INVOICE_PENDING_SHARE_EDIT_AMOUNT: '/invoices/:teamId/:rootInvoiceId/share-pending-invoice/edit-amount',
  INVOICE_PENDING_SHARE_COLLECT_PAYMENT: '/invoices/:teamId/:rootInvoiceId/share-pending-invoice/collect-payment',
  INVOICE_RECEIPT_SHARE: '/invoices/:teamId/:rootInvoiceId/share-receipt/:receiptId',
  INVOICE_SHARE_INVOICE: '/invoices/:teamId/:rootInvoiceId/share-invoice/:invoiceId',
  INVOICE_SHARE_PENDING_INVOICE: '/invoices/:teamId/:rootInvoiceId/share-pending-invoice/:invoiceId',
  INVOICE_SHARE_PENDING_INVOICE_QR: '/invoices/:teamId/:rootInvoiceId/share-pending-invoice/:invoiceId/share-qr',
  INVOICE_SHARE_PENDING_INVOICE_URL: '/invoices/:teamId/:rootInvoiceId/share-pending-invoice/:invoiceId/share-url',
  INVOICE_SHARE_PENDING_INVOICE_EDIT_AMOUNT:
    '/invoices/:teamId/:rootInvoiceId/share-pending-invoice/:invoiceId/edit-amount',
  INVOICE_SHARE_PENDING_INVOICE_COLLECT_PAYMENT:
    '/invoices/:teamId/:rootInvoiceId/share-pending-invoice/:invoiceId/collect-payment',

  INVOICE_BY_ID_COLLECT_PAYMENT: '/invoices/:teamId/:rootInvoiceId/invoice/collect-payment',
  INVOICE_BY_ID_EDIT_AMOUNT: '/invoices/:teamId/:rootInvoiceId/invoice/edit-amount',
  INVOICE_INVOICE_BY_ID_COLLECT_PAYMENT: '/invoices/:teamId/:rootInvoiceId/invoice/:invoiceId/collect-payment',
  INVOICE_INVOICE_BY_ID_EDIT_AMOUNT: '/invoices/:teamId/:rootInvoiceId/invoice/:invoiceId/edit-amount',

  INVOICE_REFUND_RECEIPT_SHARE: '/invoices/:teamId/:rootInvoiceId/share-refund-receipt/:receiptId',
  INVOICE_RECEIPT_SHARE_INVOICE: '/invoices/:teamId/:rootInvoiceId/share-receipt/:receiptId',
  INVOICE_DELETE: '/invoices/:teamId/:rootInvoiceId/delete-invoice',
  INVOICE_DELETE_INVOICE: '/invoices/:teamId/:rootInvoiceId/delete-invoice/:invoiceId',
  INVOICE_RECORD_PAYMENT: '/invoices/:teamId/:rootInvoiceId/record-payment',
  INVOICE_RECORD_PAYMENT_INVOICE: '/invoices/:teamId/:rootInvoiceId/record-payment/:invoiceId',
  INVOICE_TXN_DETAIL: '/invoices/:teamId/:rootInvoiceId/receipt/:receiptId',
  INVOICE_RECEIPT_CREATE_REFUND: '/invoices/:teamId/:rootInvoiceId/create-refund/:receiptId',
  INVOICE_RECEIPT_INITIATE_REFUND: '/invoices/:teamId/:rootInvoiceId/initiate-refund/:receiptId',
  INVOICE_RECEIPT_REFUND_SUCCESS: '/invoices/:teamId/:rootInvoiceId/refund-success/:receiptId',
  INVOICE_RECEIPT_REFUND_FAILED: '/invoices/:teamId/:rootInvoiceId/refund-failed/:receiptId',
  INVOICE_RECEIPT_REFUND: '/invoices/:teamId/:rootInvoiceId/refund-receipt/:receiptId',
  INVOICE_PAYOUT: '/invoices/:teamId/:rootInvoiceId/payout/:payoutId',
  INVOICE_PAYOUT_TXNS: '/invoices/:teamId/:rootInvoiceId/payout/:payoutId/transactions',
  INVOICE_DISPUTE_BY_ID: '/invoices/:teamId/:rootInvoiceId/dispute/:disputeId',
  INVOICE_JOB_BY_ID: '/invoices/:teamId/:rootInvoiceId/jobs/:jobId',
  INVOICE_ESTIMATE: '/invoices/:teamId/:rootInvoiceId/estimate/:estimateId',
  INVOICE_ESTIMATE_SHARE: '/invoices/:teamId/:rootInvoiceId/share-estimate/:estimateId',
  INVOICE_HISTORY: '/invoices/:teamId/:rootInvoiceId/history',
  INVOICE_INVOICE_HISTORY: '/invoices/:teamId/:rootInvoiceId/history/:invoiceId',
  INVOICE_ISSUE_REFUND: '/invoices/:teamId/:rootInvoiceId/issue-refund',
  INVOICE_INVOICE_ISSUE_REFUND: '/invoices/:teamId/:rootInvoiceId/issue-refund/:invoiceId',

  INVOICES_CREATE: '/invoices/create',
  INVOICES_EDIT: '/invoices/edit/:invoiceId',
  INVOICES_PREVIEW: '/invoices/preview',
  INVOICES_EDIT_PREVIEW: '/invoices/edit/:invoiceId/preview',
  CARDS: '/cards',
  BANKING_HOME: '/bankHome',
  LIMITS: '/paymentLimits',
  TEAMS_HOME: 'manageTeam',
  ACCOUNT_SETTINGS: '/account-settings',
  ACCOUNT_SETTINGS_MY_ACCOUNT: '/account-settings/my-account',
  ACCOUNT_SETTINGS_CREDITS_REWARDS: '/account-settings/credits-rewards',
  RECEIPTS: '/payments/receipts',
  RECEIPT_BY_ID: '/payments/receipts/:teamId/:rootReceiptId/receipt',
  RECEIPT_RECEIPT_BY_ID: '/payments/receipts/:teamId/:rootReceiptId/receipt/:receiptId',
  RECEIPT_SHARE: '/payments/receipts/:teamId/:rootReceiptId/share-receipt/:receiptId',
  RECEIPT_REFUND_RECEIPT_SHARE: '/payments/receipts/:teamId/:rootReceiptId/share-refund-receipt/:receiptId',

  RECEIPT_INVOICE_SHARE: '/payments/receipts/:teamId/:rootReceiptId/share-invoice/:invoiceId',
  RECEIPT_PENDING_INVOICE_SHARE: '/payments/receipts/:teamId/:rootReceiptId/share-pending-invoice/:invoiceId',
  RECEIPT_PENDING_INVOICE_SHARE_QR:
    '/payments/receipts/:teamId/:rootReceiptId/share-pending-invoice/:invoiceId/share-qr',
  RECEIPT_PENDING_INVOICE_SHARE_URL:
    '/payments/receipts/:teamId/:rootReceiptId/share-pending-invoice/:invoiceId/share-url',
  RECEIPT_REFUND: '/payments/receipts/:teamId/:rootReceiptId/refund',
  RECEIPT_CREATE_REFUND: '/payments/receipts/:teamId/:rootReceiptId/create-refund',
  RECEIPT_INITIATE_REFUND: '/payments/receipts/:teamId/:rootReceiptId/initiate-refund',
  RECEIPT_REFUND_SUCCESS: '/payments/receipts/:teamId/:rootReceiptId/refund-success',
  RECEIPT_REFUND_FAILED: '/payments/receipts/:teamId/:rootReceiptId/refund-failed',
  RECEIPT_RECEIPT_CREATE_REFUND: '/payments/receipts/:teamId/:rootReceiptId/create-refund/:receiptId',
  RECEIPT_RECEIPT_INITIATE_REFUND: '/payments/receipts/:teamId/:rootReceiptId/initiate-refund/:receiptId',
  RECEIPT_RECEIPT_REFUND_SUCCESS: '/payments/receipts/:teamId/:rootReceiptId/refund-success/:receiptId',
  RECEIPT_RECEIPT_REFUND_FAILED: '/payments/receipts/:teamId/:rootReceiptId/refund-failed/:receiptId',
  RECEIPT_RECEIPT_REFUND: '/payments/receipts/:teamId/:rootReceiptId/refund/:receiptId',
  RECEIPT_PAYOUT_BY_ID: '/payments/receipts/:teamId/:rootReceiptId/payout/:payoutId',
  RECEIPT_PAYOUT_BY_ID_TXNS: '/payments/receipts/:teamId/:rootReceiptId/payout/:payoutId/transactions',
  RECEIPT_INVOICE: '/payments/receipts/:teamId/:rootReceiptId/invoice/:invoiceId',
  RECEIPT_JOB_DETAILS: '/payments/receipts/:teamId/:rootReceiptId/jobs/:jobId',
  RECEIPT_CUSTOMER_BY_ID: '/payments/receipts/:teamId/:rootReceiptId/customer/:customerId',
  RECEIPT_INVOICE_DETAILS: '/payments/receipts/:teamId/:rootReceiptId/invoice-details/:invoiceId',
  RECEIPT_INVOICE_DELETE: '/payments/receipts/:teamId/:rootReceiptId/delete-invoice/:invoiceId',
  RECEIPT_INVOICE_RECORD_PAYMENT: '/payments/receipts/:teamId/:rootReceiptId/record-payment/:invoiceId',
  TRANSACTIONS: '/transactions',
  RECEIPT_DISPUTE_BY_ID: '/payments/receipts/:teamId/:rootReceiptId/dispute/:disputeId',
  RECEIPT_ESTIMATE: '/payments/receipts/:teamId/:rootReceiptId/estimate/:estimateId',
  RECEIPT_ESTIMATE_SHARE: '/payments/receipts/:teamId/:rootReceiptId/share-estimate/:estimateId',
  RECEIPT_INVOICE_EDIT_AMOUNT: '/payments/receipts/:teamId/:rootReceiptId/invoice/:invoiceId/edit-amount',
  RECEIPT_INVOICE_COLLECT_PAYMENT: '/payments/receipts/:teamId/:rootReceiptId/invoice/:invoiceId/collect-payment',
  RECEIPT_INVOICE_HISTORY: '/payments/receipts/:teamId/:rootReceiptId/history/:invoiceId',
  RECEIPT_INVOICE_ISSUE_REFUND: '/payments/receipts/:teamId/:rootReceiptId/issue-refund/:invoiceId',

  PAYOUTS: '/payouts',
  PAYOUTS_BALANCE: '/payouts/balance',
  PAYOUTS_LIST: '/payouts/list',
  PAYOUT_LIST_TXNS: '/payouts/list/:teamId/:rootPage/:payoutId/transactions',
  PAYOUT_BALANCE_TXNS: '/payouts/balance/:teamId/:rootPage/:payoutId/transactions',
  PAYOUTS_BALANCE_TOTAL_DETALS: '/payouts/balance/total-details',
  PAYOUTS_BALANCE_UPCOMING_PAYOUTS: '/payouts/balance/upcoming-payouts',
  PAYOUTS_BALANCE_HELD_IN_RESERVE: '/payouts/balance/held-in-reserve',
  PAYOUTS_BALANCE_IN_TRANSIT_PAYOUTS: '/payouts/balance/in-transit-payouts/:rootPage',
  PAYOUT_BALANCE_RECEIPT_DETAIL: '/payouts/balance/:teamId/:rootPage/receipt/:receiptId',
  PAYOUT_BALANCE_RECEIPT_SHARE: '/payouts/balance/:teamId/:rootPage/share-receipt/:receiptId',
  PAYOUT_BALANCE_INVOICE_SHARE: '/payouts/balance/:teamId/:rootPage/share-invoice/:invoiceId',
  PAYOUT_BALANCE_PENDING_INVOICE_SHARE: '/payouts/balance/:teamId/:rootPage/share-pending-invoice/:invoiceId',
  PAYOUT_BALANCE_PENDING_INVOICE_SHARE_QR:
    '/payouts/balance/:teamId/:rootPage/share-pending-invoice/:invoiceId/share-qr',
  PAYOUT_BALANCE_PENDING_INVOICE_SHARE_URL:
    '/payouts/balance/:teamId/:rootPage/share-pending-invoice/:invoiceId/share-url',
  PAYOUT_BALANCE_REFUND_RECEIPT_SHARE: '/payouts/balance/:teamId/:rootPage/share-refund-receipt/:receiptId',
  PAYOUT_BALANCE_RECEIPT_CREATE_REFUND: '/payouts/balance/:teamId/:rootPage/create-refund/:receiptId',
  PAYOUT_BALANCE_RECEIPT_INITIATE_REFUND: '/payouts/balance/:teamId/:rootPage/initiate-refund/:receiptId',
  PAYOUT_BALANCE_RECEIPT_REFUND_SUCCESS: '/payouts/balance/:teamId/:rootPage/refund-success/:receiptId',
  PAYOUT_BALANCE_RECEIPT_REFUND_FAILED: '/payouts/balance/:teamId/:rootPage/refund-failed/:receiptId',
  PAYOUT_BALANCE_PAYOUT_BY_ID: '/payouts/balance/:teamId/:rootPage/payout/:payoutId',
  PAYOUT_BALANCE_INVOICE: '/payouts/balance/:teamId/:rootPage/invoice/:invoiceId',
  PAYOUT_BALANCE_CUSTOMER_BY_ID: '/payouts/balance/:teamId/:rootPage/customer/:customerId',
  PAYOUT_BALANCE_INVOICE_DETAILS: '/payouts/balance/:teamId/:rootPage/invoice-details/:invoiceId',
  PAYOUT_BALANCE_JOB_DETAILS: '/payouts/balance/:teamId/:rootPage/jobs/:jobId',
  PAYOUT_BALANCE_RECEIPT_REFUND: '/payouts/balance/:teamId/:rootPage/refund-receipt/:receiptId',
  PAYOUT_BALANCE_DISPUTE_BY_ID: '/payouts/balance/:teamId/:rootPage/dispute/:disputeId',
  PAYOUT_BALANCE_INVOICE_DELETE: '/payouts/balance/:teamId/:rootPage/delete-invoice/:invoiceId',
  PAYOUT_BALANCE_INVOICE_HISTORY: '/payouts/balance/:teamId/:rootPage/history/:invoiceId',
  PAYOUT_BALANCE_INVOICE_ISSUE_REFUND: '/payouts/balance/:teamId/:rootPage/issue-refund/:invoiceId',
  PAYOUT_BALANCE_INVOICE_RECORD_PAYMENT: '/payouts/balance/:teamId/:rootPage/record-payment/:invoiceId',
  PAYOUT_LIST_PAYOUT_BY_ID: '/payouts/list/:teamId/:rootPage/payout/:payoutId',
  PAYOUT_LIST_RECEIPT: '/payouts/list/:teamId/:rootPage/receipt/:receiptId',
  PAYOUT_LIST_CUSTOMER: '/payouts/list/:teamId/:rootPage/customer/:customerId',
  PAYOUT_LIST_INVOICE: '/payouts/list/:teamId/:rootPage/invoice/:invoiceId',
  PAYOUT_LIST_INVOICE_DETAILS: '/payouts/list/:teamId/:rootPage/invoice-details/:invoiceId',
  PAYOUT_LIST_JOB_DETAILS: '/payouts/list/:teamId/:rootPage/jobs/:jobId',
  PAYOUT_LIST_RECEIPT_CREATE_REFUND: '/payouts/list/:teamId/:rootPage/create-refund/:receiptId',
  PAYOUT_LIST_RECEIPT_INITIATE_REFUND: '/payouts/list/:teamId/:rootPage/initiate-refund/:receiptId',
  PAYOUT_LIST_RECEIPT_REFUND_SUCCESS: '/payouts/list/:teamId/:rootPage/refund-success/:receiptId',
  PAYOUT_LIST_RECEIPT_REFUND_FAILED: '/payouts/list/:teamId/:rootPage/refund-failed/:receiptId',
  PAYOUT_LIST_RECEIPT_SHARE: '/payouts/list/:teamId/:rootPage/share-receipt/:receiptId',
  PAYOUT_LIST_INVOICE_SHARE: '/payouts/list/:teamId/:rootPage/share-invoice/:invoiceId',
  PAYOUT_LIST_PENDING_INVOICE_SHARE: '/payouts/list/:teamId/:rootPage/share-pending-invoice/:invoiceId',
  PAYOUT_LIST_PENDING_INVOICE_SHARE_QR: '/payouts/list/:teamId/:rootPage/share-pending-invoice/:invoiceId/share-qr',
  PAYOUT_LIST_PENDING_INVOICE_SHARE_URL: '/payouts/list/:teamId/:rootPage/share-pending-invoice/:invoiceId/share-url',
  PAYOUT_LIST_REFUND_RECEIPT_SHARE: '/payouts/list/:teamId/:rootPage/share-refund-receipt/:receiptId',
  PAYOUT_LIST_INVOICE_DELETE: '/payouts/list/:teamId/:rootPage/delete-invoice/:invoiceId',
  PAYOUT_LIST_INVOICE_HISTORY: '/payouts/list/:teamId/:rootPage/history/:invoiceId',
  PAYOUT_LIST_INVOICE_ISSUE_REFUND: '/payouts/list/:teamId/:rootPage/issue-refund/:invoiceId',
  PAYOUT_LIST_INVOICE_RECORD_PAYMENT: '/payouts/list/:teamId/:rootPage/record-payment/:invoiceId',
  PAYOUT_LIST_RECEIPT_REFUND: '/payouts/list/:teamId/:rootPage/refund-receipt/:receiptId',
  PAYOUT_LIST_DISPUTE: '/payouts/list/:teamId/:rootPage/dispute/:disputeId',
  PAYOUTS_BALANCE_UPCOMING_PAYOUTS_TXNS: '/payouts/balance/:teamId/upcoming-payouts/:rootPage/transactions',
  PAYOUTS_BALANCE_ESTIMATE: '/payouts/balance/:teamId/:rootPage/estimate/:estimateId',
  PAYOUT_LIST_ESTIMATE: '/payouts/list/:teamId/:rootPage/estimate/:estimateId',
  PAYOUT_LIST_ESTIMATE_SHARE: '/payouts/list/:teamId/:rootPage/share-estimate/:estimateId',
  PAYOUT_BALANCE_ESTIMATE_SHARE: '/payouts/balance/:teamId/:rootPage/share-estimate/:estimateId',

  BANK_APPLICATION_STATUS: '/payouts/application-status',
  CONNECT_ONBOARDING: '/payouts/connect-onboarding',

  CUSTOMERS: '/customers',
  CUSTOMER_BY_ID: '/customers/:teamId/:rootCustomerId/customer',
  CUSTOMER_INVOICE: '/customers/:teamId/:rootCustomerId/invoice/:invoiceId',
  CUSTOMER_INVOICE_DETAILS: '/customers/:teamId/:rootCustomerId/invoice-details/:invoiceId',
  CUSTOMER_JOB_DETAILS: '/customers/:teamId/:rootCustomerId/jobs/:jobId',
  CUSTOMER_RECEIPT: '/customers/:teamId/:rootCustomerId/receipt/:receiptId',
  CUSTOMER_RECEIPT_SHARE: '/customers/:teamId/:rootCustomerId/share-receipt/:receiptId',
  CUSTOMER_INVOICE_SHARE: '/customers/:teamId/:rootCustomerId/share-invoice/:invoiceId',
  CUSTOMER_PENDING_INVOICE_SHARE: '/customers/:teamId/:rootCustomerId/share-pending-invoice/:invoiceId',
  CUSTOMER_PENDING_INVOICE_SHARE_QR: '/customers/:teamId/:rootCustomerId/share-pending-invoice/:invoiceId/share-qr',
  CUSTOMER_PENDING_INVOICE_SHARE_URL: '/customers/:teamId/:rootCustomerId/share-pending-invoice/:invoiceId/share-url',
  CUSTOMER_REFUND_RECEIPT_SHARE: '/customers/:teamId/:rootCustomerId/share-refund-receipt/:receiptId',
  CUSTOMER_INVOICE_DELETE: '/customers/:teamId/:rootCustomerId/delete-invoice/:invoiceId',
  CUSTOMER_INVOICE_RECORD_PAYMENT: '/customers/:teamId/:rootCustomerId/record-payment/:invoiceId',
  CUSTOMER_CREATE_REFUND: '/customers/:teamId/:rootCustomerId/create-refund/:receiptId',
  CUSTOMER_INITIATE_REFUND: '/customers/:teamId/:rootCustomerId/initiate-refund/:receiptId',
  CUSTOMER_REFUND_SUCCESS: '/customers/:teamId/:rootCustomerId/refund-success/:receiptId',
  CUSTOMER_REFUND_FAILED: '/customers/:teamId/:rootCustomerId/refund-failed/:receiptId',
  CUSTOMER_PAYOUT: '/customers/:teamId/:rootCustomerId/payout/:payoutId',
  CUSTOMER_PAYOUT_TXNS: '/customers/:teamId/:rootCustomerId/payout/:payoutId/transactions',
  CUSTOMER_RECEIPT_REFUND: '/customers/:teamId/:rootCustomerId/refund-receipt/:receiptId',
  CUSTOMER_DISPUTE_BY_ID: '/customers/:teamId/:rootCustomerId/dispute/:disputeId',
  CUSTOMER_ESTIMATE_BY_ID: '/customers/:teamId/:rootCustomerId/estimate/:estimateId',
  CUSTOMER_ESTIMATE_SHARE: '/customers/:teamId/:rootCustomerId/share-estimate/:estimateId',
  CUSTOMER_INVOICE_EDIT_AMOUNT: '/customers/:teamId/:rootCustomerId/invoice/:invoiceId/edit-amount',
  CUSTOMER_INVOICE_COLLECT_PAYMENT: '/customers/:teamId/:rootCustomerId/invoice/:invoiceId/collect-payment',
  CUSTOMER_INVOICE_HISTORY: '/customers/:teamId/:rootCustomerId/history/:invoiceId',
  CUSTOMER_INVOICE_ISSUE_REFUND: '/customers/:teamId/:rootCustomerId/issue-refund/:invoiceId',

  SETTINGS: '/settings',
  INVOICE_SETTINGS: '/settings/invoice-settings',
  PAYMENT_SETTINGS: '/settings/payment-settings',
  PAYOUTS_SETTINGS: '/settings/payouts-settings',
  TAX_FORMS_SETTINGS: '/settings/tax-forms',
  SERVICE_AREAS_SETTINGS: '/settings/service-areas',
  ADD_SERVICE_AREA: '/settings/service-areas/add',
  EDIT_SERVICE_AREA: '/settings/service-areas/edit/:id',
  TEAM_PROFILE: '/team-profile',
  MANAGE_TEAM: '/manage-team',
  CREATE_TEAM: '/create-team',
  MEMBER_PROFILE: '/manage-team/:teamId/:memberId/member',
  INVITED_MEMBER_PROFILE: '/manage-team/:teamId/member/:phoneNumber/invited',
  CREATE_INVITE: '/manage-team/invite',
  TEAM_MEMBER_BY_ID: '/manage-team/:teamId/:memberId/member',
  BANKING: '/banking',
  BANKING_ONBOARDING: '/banking-onboarding',
  DEBIT_CARDS: '/debit-cards',
  ACCOUNTS: '/accounts',
  AWAITING_DOCUMENTS: '/awaitingDocuments',
  CREDITS_HISTORY: '/preCredits',

  CATALOG_ITEMS: '/catalog/items',
  ITEMS_CREATE: '/items/create',
  ITEMS_EDIT: '/items/edit/:itemId',
  ITEMS_DUPLICATE: '/items/duplicate/:itemId',

  CATALOG_CATEGORIES: '/catalog/categories',
  CATEGORIES_CREATE: '/categories/create',
  CATEGORIES_EDIT: '/categories/edit/:categoryId',

  CATALOG_TAXES: '/catalog/taxes',
  TAXES_CREATE: '/taxes/create',
  TAXES_EDIT: '/taxes/edit/:taxId',

  CATALOG_SERVICE_CHARGES: '/catalog/service-charges',
  SERVICE_CHARGES_CREATE: '/service-charges/create',
  SERVICE_CHARGES_EDIT: '/service-charges/edit/:id',

  DISPUTES: '/payments/disputes',
  DISPUTE_BY_ID: '/payments/disputes/:teamId/:rootDisputeId/dispute',
  DISPUTE_RECEIPT_DETAILS: '/payments/disputes/:teamId/:rootDisputeId/receipt/:receiptId',
  RESPOND_TO_DIPUTES: '/payments/disputes/:teamId/respond/:rootDisputeId',
  DISPUTES_UPDATE_EVIDENCE: '/payments/disputes/:teamId/update-evidence/:rootDisputeId',
  DISPUTES_REVIEW_SUBMIT: '/payments/disputes/:teamId/review-and-submit/:rootDisputeId',
  DISPUTES_VIEW_EVIDENCE: '/payments/disputes/:teamId/view-evidence/:rootDisputeId',

  DISPUTE_DISPUTE_BY_ID: '/payments/disputes/:teamId/:rootDisputeId/dispute/:disputeId',
  DISPUTE_CUSTOMER: '/payments/disputes/:teamId/:rootDisputeId/customer/:customerId',
  DISPUTE_INVOICE: '/payments/disputes/:teamId/:rootDisputeId/invoice/:invoiceId',
  DISPUTE_INVOICE_DETAILS: '/payments/disputes/:teamId/:rootDisputeId/invoice-details/:invoiceId',
  DISPUTE_JOB_DETAILS: '/payments/disputes/:teamId/:rootDisputeId/jobs/:jobId',
  DISPUTE_RECEIPT_SHARE: '/payments/disputes/:teamId/:rootDisputeId/share-receipt/:receiptId',
  DISPUTE_INVOICE_SHARE: '/payments/disputes/:teamId/:rootDisputeId/share-invoice/:invoiceId',
  DISPUTE_PENDING_INVOICE_SHARE: '/payments/disputes/:teamId/:rootDisputeId/share-pending-invoice/:invoiceId',
  DISPUTE_PENDING_INVOICE_SHARE_QR:
    '/payments/disputes/:teamId/:rootDisputeId/share-pending-invoice/:invoiceId/share-qr',
  DISPUTE_PENDING_INVOICE_SHARE_URL:
    '/payments/disputes/:teamId/:rootDisputeId/share-pending-invoice/:invoiceId/share-url',
  DISPUTE_REFUND_RECEIPT_SHARE: '/payments/disputes/:teamId/:rootDisputeId//share-refund-receipt/:receiptId',
  DISPUTE_INVOICE_DELETE: '/payments/disputes/:teamId/:rootDisputeId/delete-invoice/:invoiceId',
  DISPUTE_INVOICE_RECORD_PAYMENT: '/payments/disputes/:teamId/:rootDisputeId/record-payment/:invoiceId',
  DISPUTE_CREATE_REFUND: '/payments/disputes/:teamId/:rootDisputeId/create-refund/:receiptId',
  DISPUTE_INITIATE_REFUND: '/payments/disputes/:teamId/:rootDisputeId/initiate-refund/:receiptId',
  DISPUTE_REFUND_SUCCESS: '/payments/disputes/:teamId/:rootDisputeId/refund-success/:receiptId',
  DISPUTE_REFUND_FAILED: '/payments/disputes/:teamId/:rootDisputeId/refund-failed/:receiptId',
  DISPUTE_PAYOUT: '/payments/disputes/:teamId/:rootDisputeId/payout/:payoutId',
  DISPUTE_PAYOUT_TXNS: '/payments/disputes/:teamId/:rootDisputeId/payout/:payoutId/transactions',
  DISPUTE_RECEIPT_REFUND: '/payments/disputes/:teamId/:rootDisputeId/refund-receipt/:receiptId',
  DISPUTE_ESTIMATE_BY_ID: '/payments/disputes/:teamId/:rootDisputeId/estimate/:estimateId',
  DISPUTE_ESTIMATE_SHARE: '/payments/disputes/:teamId/:rootDisputeId/share-estimate/:estimateId',
  DISPUTE_INVOICE_EDIT_AMOUNT: '/payments/disputes/:teamId/:rootDisputeId/invoice/:invoiceId/edit-amount',
  DISPUTE_INVOICE_COLLECT_PAYMENT: '/payments/disputes/:teamId/:rootDisputeId/invoice/:invoiceId/collect-payment',
  DISPUTE_INVOICE_HISTORY: '/payments/disputes/:teamId/:rootDisputeId/history/:invoiceId',

  INTEGRATIONS: '/integrations',
  DEVELOPER_API: '/integrations/developer-api',
  WEBHOOKS: '/integrations/webhooks',
  QUICKBOOKS: '/integrations/quickbooks',
  QUICKBOOKS_LOGIN: '/integrations/quickbooks/login',
  QUICKBOOKS_SETTINGS: '/integrations/quickbooks/settings',
  ESTIMATE_INTEGRATION: '/integrations/estimate',
  FIELD_SERVICE_MANAGEMENT: '/integrations/field-service-management',

  LENDICA_WEBVIEW: '/lendica-webview',
  CAPITAL_WEBVIEW: '/capital-webview',
  ONBOARDING_CAPITAL_WEBVIEW: '/onboarding-capital-webview',
  BUSINESS_LOANS: '/business-loans',

  SIGNIN: '/sign-in',
  SIGN_UP_QR: '/sign-up-qr',
  SIGN_UP: '/sign-up',
  RESET: '/reset',

  REDIRECT: '/redirect',

  DIGITAL_ONBOARDING_NAME: '/digital-onboarding-name',
  DIGITAL_ONBOARDING_EMAIL: '/digital-onboarding-email',
  DIGITAL_ONBOARDING_PROFESSION: '/digital-onboarding-profession',
  DIGITAL_ONBOARDING_BUSINESS_NAME: '/digital-onboarding-business-name',
  DIGITAL_ONBOARDING_EMPLOYEES: '/digital-onboarding-employees',
  DIGITAL_ONBOARDING_REFERRAL_SOURCE: '/digital-onboarding-referral-source',
  DIGITAL_ONBOARDING_WEBSITE: '/digital-onboarding-website',
  DIGITAL_ONBOARDING_EMAIL_ERROR: '/digital-onboarding-email-error',

  DECLINED: '/declined',
  BLOCKED: '/blocked',
  WAITING_LIST: '/waiting-list',

  // Add these new routes for estimates
  ESTIMATES: '/estimates',
  ESTIMATE: '/estimate',
  ESTIMATE_BY_ID: '/estimates/:teamId/:rootEstimateId/estimate',
  ESTIMATE_BY_ID_DETAILS: '/estimates/:teamId/:rootEstimateId/estimate-details',
  ESTIMATE_CUSTOMER_BY_ID: '/estimates/:teamId/:rootEstimateId/customer/:customerId',
  ESTIMATE_INVOICE_BY_ID: '/estimates/:teamId/:rootEstimateId/invoice/:invoiceId',
  ESTIMATE_INVOICE_DETAILS: '/estimates/:teamId/:rootEstimateId/invoice-details/:invoiceId',
  ESTIMATE_JOB_DETAILS: '/estimates/:teamId/:rootEstimateId/jobs/:jobId',
  ESTIMATE_RECEIPT_BY_ID: '/estimates/:teamId/:rootEstimateId/receipt/:receiptId',
  ESTIMATE_SHARE: '/estimates/:teamId/:rootEstimateId/share-estimate/:estimateId',
  ESTIMATE_INVOICE_SHARE: '/estimates/:teamId/:rootEstimateId/share-invoice/:invoiceId',
  ESTIMATE_PENDING_SHARE: '/estimates/:teamId/:rootEstimateId/share-pending-estimate/:estimateId',
  ESTIMATE_PENDING_SHARE_QR: '/estimates/:teamId/:rootEstimateId/share-pending-estimate/:estimateId/share-qr',
  ESTIMATE_PENDING_SHARE_URL: '/estimates/:teamId/:rootEstimateId/share-pending-estimate/:estimateId/share-url',
  ESTIMATE_INVOICE_RECORD_PAYMENT: '/estimates/:teamId/:rootEstimateId/record-payment/:invoiceId',
  ESTIMATE_INVOICE_DELETE: '/estimates/:teamId/:rootEstimateId/delete-invoice/:invoiceId',
  ESTIMATE_DISPUTE_BY_ID: '/estimates/:teamId/:rootEstimateId/dispute/:disputeId',
  ESTIMATE_PAYOUT: '/estimates/:teamId/:rootEstimateId/payout/:payoutId',
  ESTIMATES_CREATE: '/estimates/create',
  ESTIMATES_DUPLICATE: '/estimates/duplicate/:estimateId',
  ESTIMATES_EDIT: '/estimates/edit/:estimateId',
  ESTIMATE_INVOICE_PENDING_SHARE: '/estimates/:teamId/:rootEstimateId/share-pending-invoice/:invoiceId',
  ESTIMATE_INVOICE_PENDING_SHARE_QR: '/estimates/:teamId/:rootEstimateId/share-pending-invoice/:invoiceId/share-qr',
  ESTIMATE_INVOICE_PENDING_SHARE_URL: '/estimates/:teamId/:rootEstimateId/share-pending-invoice/:invoiceId/share-url',
  ESTIMATE_REFUND_RECEIPT: '/estimates/:teamId/:rootEstimateId/refund-receipt/:receiptId',
  ESTIMATE_ESTIMATE_BY_ID: '/estimates/:teamId/:rootEstimateId/estimate/:estimateId',
  ESTIMATE_CREATE_REFUND: '/estimates/:teamId/:rootEstimateId/create-refund/:receiptId',
  ESTIMATE_INITIATE_REFUND: '/estimates/:teamId/:rootEstimateId/initiate-refund/:receiptId',
  ESTIMATE_REFUND_SUCCESS: '/estimates/:teamId/:rootEstimateId/refund-success/:receiptId',
  ESTIMATE_REFUND_FAILED: '/estimates/:teamId/:rootEstimateId/refund-failed/:receiptId',
  ESTIMATE_RECEIPT_SHARE: 'estimates/:teamId/:rootEstimateId/share-receipt/:receiptId',
  ESTIMATE_REFUND_RECEIPT_SHARE: '/estimates/:teamId/:rootEstimateId/share-refund-receipt/:receiptId',
  ESTIMATE_DELETE_INVOICE: '/estimates/:teamId/:rootEstimateId/delete-invoice/:invoiceId',
  ESTIMATE_INVOICE_EDIT_AMOUNT: '/estimates/:teamId/:rootEstimateId/invoice/:invoiceId/edit-amount',
  ESTIMATE_INVOICE_COLLECT_PAYMENT: '/estimates/:teamId/:rootEstimateId/invoice/:invoiceId/collect-payment',
  ESTIMATE_INVOICE_HISTORY: '/estimates/:teamId/:rootEstimateId/history/:invoiceId',
  ESTIMATE_INVOICE_ISSUE_REFUND: '/estimates/:teamId/:rootEstimateId/issue-refund/:invoiceId',
  ESTIMATE_SETTINGS: '/settings/estimate-settings',

  MAPS: '/maps',
  MAP_VIEWS_SETTINGS: '/settings/map-views',

  COMMISSION_SETTINGS: '/settings/commission-settings',
  CREATE_COMMISSION_RULE: '/settings/commission-settings/create-rule',
  EDIT_COMMISSION_RULE: '/settings/commission-settings/edit-rule/:id',
  EDIT_COMMISSION_RULE_BASE: '/settings/commission-settings/edit-rule',

  TAGS: '/settings/tags',
  CREATE_TAG: '/settings/tags/create',
  EDIT_TAG: '/settings/tags/edit/:tagId',

  EXTERNAL_COMPANY_SETTINGS: '/settings/external-company',
  ADD_EXTERNAL_COMPANY: '/settings/external-company/add',
  EDIT_EXTERNAL_COMPANY: '/settings/external-company/edit-company/:id',

  PAY_SCHEDULE_SETTINGS: '/settings/pay-schedule',
  ADJUSTMENT_SETTINGS: '/settings/adjustment-settings',
  ACCOUNTING_PAY_RUNS: '/accounting/pay-runs',
  ACCOUNTING_EXTERNAL_COMPANY: '/accounting/external-company',
  PAY_PERIOD_REVIEW: '/accounting/pay-runs/pay-period-review/:teamId/:payRunId',
  PAY_PERIOD_REVIEW_RECENT_ACTIVITY: '/accounting/pay-runs/pay-period-review/:teamId/:payRunId/recent-activity',
  ACCOUNTING_PAY_RUNS_LIST: '/accounting/pay-runs/list',
  ACCOUNTING_PAY_RUNS_MEMBER_REVIEW: '/accounting/pay-runs/:payRunId/members/:merchantId',
  ACCOUNTING_PAY_RUNS_JOB_REVIEW: '/accounting/pay-runs/:payRunId/members/:merchantId/jobs/:jobId',

  REPORTS: '/reports',
  EXTERNAL_COMPANY_REPORT: '/reports/external-company',
  COMMISSION_REPORT: '/reports/commission',
  EXPENSE_REPORT: '/reports/expense',
  PAYMENT_REPORT: '/reports/payment',
  TIPS_REPORT: '/reports/tips',
  AREA_PERFORMANCE_REPORT: '/reports/area-performance',
  JOB_PROFITABILITY_REPORT: '/reports/job-profitability',
  CAPITAL_FINANCING: '/financing',

  CARD_DETAILS_WEBVIEW: '/card-details-webview',
  PIN_WEBVIEW: '/pin-webview',
  CUSTOMER_ADD_COF_WEBVIEW: '/card-on-file',
  APP_STORE_REDIRECT_WEBVIEW: '/app-store-redirect'
};

export default routesPath;
